import React, {PureComponent} from 'react'
import {withStyles} from '@material-ui/core/styles/index';
import Button from "@material-ui/core/Button";
import Grid from '@material-ui/core/Grid';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {postApplicationAction} from "../../../api";

const styles = theme => ({
    container: {
        padding: theme.spacing(0),
        [theme.breakpoints.up(450)]: {
            padding: theme.spacing(2) + 'px ' + theme.spacing(2) + 'px ' + theme.spacing(1) + 'px ' + theme.spacing(2) + 'px ',
        }
    },
    actionBarRoot: {
        padding: theme.spacing(1) + 'px ' + theme.spacing(1) + 'px 0 ' + theme.spacing(1) + 'px ',
        maxWidth: 1466,
        margin: 'auto',
        [theme.breakpoints.up(450)]: {
            padding: theme.spacing(1) + 'px ' + theme.spacing(3) + 'px 0 ' + theme.spacing(4) + 'px ',
        }
    },
    button: {
        margin: '0 ' + theme.spacing(1) + 'px',
        marginBottom: theme.spacing(1) + 'px ',
    },
    acceptButton: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    iconButton: {
        fontSize: '1.14rem',
        minWidth: 0,
        marginBottom: theme.spacing(1),
    },
    loadingIconButton: {
        fontSize: '1.14rem',
        minWidth: 0,
        marginBottom: theme.spacing(1),
        color: theme.palette.primary['600'],
    },
    rejectButton: {
        borderColor: '#f44336',
        color: '#f44336',
    },
    hideOnMobile: {
        display: 'none',
        [theme.breakpoints.up(800)]: {
            display: 'inline',
        }
    },
    hideOnSmallMobile: {
        display: 'none',
        [theme.breakpoints.up(450)]: {
            display: 'inline',
        }
    },
    leftIcon: {
        height: '1.5rem',
        [theme.breakpoints.up(800)]: {
            marginRight: 10,
            marginLeft: -3,
        }
    },
    smallTextLeftIcon: {
        [theme.breakpoints.up(450)]: {
            marginRight: 10,
            marginLeft: -3,
        }
    },
    smallPadding: {
        [theme.breakpoints.down(450)]: {
            paddingTop: '12px!important',
        }
    },
    smallPaddingBottom: {
        [theme.breakpoints.down(450)]: {
            paddingBottom: '21px!important',
        }
    },
    showSm: {
        display: 'none',
        [theme.breakpoints.up(450)]: {
            display: 'inline',
        },
        [theme.breakpoints.up(800)]: {
            display: 'none',
        }
    },
    showMd: {
        display: 'none',
        [theme.breakpoints.up(800)]: {
            display: 'inline',
        }
    },
});


class Actions extends PureComponent {
    state = {};

    onClick = (action) => {
        postApplicationAction(this.props.application.id, action).then(() => {
            this.props.refresh()
        })
    }

    render() {
        const {classes, actions, refresh, isLoading} = this.props;

        return (
            <Grid container className={classes.actionBarRoot}>
                <Grid item xs={1}>
                    {!isLoading && <Button className={classes.iconButton} onClick={refresh}>
                        <FontAwesomeIcon size={'lg'} icon={['fal', 'redo']}/>
                    </Button>}
                    {isLoading && <Button className={classes.loadingIconButton} onClick={refresh}><FontAwesomeIcon
                        icon={['fal', 'spinner']} pulse size="lg"/>
                    </Button>}
                </Grid>
                <Grid item xs={11} style={{textAlign: 'right'}}>
                    {actions && actions.map((action, key) => {
                        let buttonClassName = ''
                        let variant = ''
                        let color = ''

                        if (action.type === 'primary') {
                            buttonClassName = classes.acceptButton
                            variant = 'contained'
                            color = 'primary'
                        }
                        if (action.type === 'outlined') {
                            buttonClassName = ''
                            variant = 'outlined'
                        }
                        if (action.type === 'reject') {
                            buttonClassName = classes.rejectButton
                            variant = 'outlined'
                        }

                        return (
                            <Button variant={variant} color={color} className={buttonClassName + ' ' + classes.button}
                                    onClick={() => this.onClick(action.action)}>
                                <FontAwesomeIcon size={'lg'} icon={['fal', action.icon]}
                                                 className={classes.leftIcon + ' ' + (action.shortLabel !== '' ? classes.smallTextLeftIcon : null)}/>
                                <span className={classes.showSm}>{action.shortLabel}</span><span
                                className={classes.showMd}>{action.label}</span>
                            </Button>)
                    })}
                </Grid>
            </Grid>
        )
    }
}


export default withStyles(styles)(Actions);
